import { Briefcase, Mail, Users, TrendingUp, Award } from "lucide-react";
import { CONTACT } from "../lib/contact";

const WHY = [
  { icon: TrendingUp, t: "Grow with real estate", d: "Work across residential, plots, commercial and investment projects." },
  { icon: Users, t: "Supportive team", d: "Learn from experienced channel-partner professionals." },
  { icon: Award, t: "Performance rewards", d: "Clear targets and recognition for great work." },
];

export default function Careers() {
  const subject = encodeURIComponent("Job application — PlotBySquare");
  return (
    <div className="bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <p className="text-xs font-bold uppercase tracking-wider text-pbs-gold">Careers</p>
        <h1 className="mt-2 text-3xl sm:text-4xl font-extrabold text-pbs-dark">Build your career with PlotBySquare</h1>
        <p className="mt-2 text-pbs-grey max-w-2xl">We're always looking for driven sales, telecalling, marketing and operations talent.</p>
        <div className="mt-8 grid sm:grid-cols-3 gap-4">
          {WHY.map((w) => (
            <div key={w.t} className="border border-pbs-line rounded-xl p-5 bg-white">
              <w.icon size={20} className="text-pbs-purple" />
              <h3 className="mt-3 font-bold text-pbs-dark text-[15px]">{w.t}</h3>
              <p className="text-sm text-pbs-grey mt-1">{w.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-8 bg-pbs-bg border border-pbs-line rounded-xl p-6 flex flex-col sm:flex-row sm:items-center gap-4 justify-between" data-testid="careers-apply">
          <div>
            <h2 className="font-bold text-pbs-dark flex items-center gap-2"><Briefcase size={18} className="text-pbs-purple" /> How to apply</h2>
            <p className="text-sm text-pbs-grey mt-1">Email your CV and the role you're interested in to <b className="text-pbs-dark">{CONTACT.career}</b>.</p>
          </div>
          <a href={`mailto:${CONTACT.career}?subject=${subject}`} data-testid="careers-email-btn" className="inline-flex items-center justify-center gap-2 bg-pbs-purple hover:bg-pbs-plum text-white font-bold px-5 py-3 rounded-lg transition-colors shrink-0"><Mail size={16} /> Email your CV</a>
        </div>
      </div>
    </div>
  );
}
